import { StackedBarchartComponent } from './stackedbarchart.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule
  ],
  exports: [StackedBarchartComponent],
  declarations: [StackedBarchartComponent]
})
export class StackedBarchartModule { }
